import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../user.service';
import { AppConfig, Redirection } from 'common';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(
    private userService : UserService,
    private redirection : Redirection,
    private appConfig : AppConfig
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.userService.logout();
      this.redirection.go(environment.urls.app);
    })
  }

}
